import React from 'react';

import {
  useArchivePartnerCompany,
  useRestorePartnerCompany,
  useDeletePartnerCompany,
} from '../../data';
import { Actions } from './Actions';

export const PartnerCompanyActions = ({
  actions,
  data,
  limit,
  onEdit,
  onDelete,
}) => {
  const [archivePartnerCompany] = useArchivePartnerCompany();
  const [restorePartnerCompany] = useRestorePartnerCompany();
  const [deletePartnerCompany] = useDeletePartnerCompany();

  const handleArchive = async () => {
    await archivePartnerCompany(data);
  };

  const handleRestore = async () => {
    await restorePartnerCompany(data);
  };

  const handleDelete = async () => {
    await deletePartnerCompany(data);
    onDelete?.();
  };

  const handleEdit = () => onEdit?.(data);

  return (
    <Actions
      actions={actions}
      onArchive={handleArchive}
      onRestore={handleRestore}
      onDelete={handleDelete}
      onEdit={handleEdit}
      limit={limit}
    />
  );
};

export default PartnerCompanyActions;
